/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Confidence_MediumInputs */

const en_directory_agent_readiness_confidence_medium = /** @type {(inputs: Directory_Agent_Readiness_Confidence_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medium confidence`)
};

const zh_directory_agent_readiness_confidence_medium = /** @type {(inputs: Directory_Agent_Readiness_Confidence_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中等置信度`)
};

/**
* | output |
* | --- |
* | "Medium confidence" |
*
* @param {Directory_Agent_Readiness_Confidence_MediumInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_confidence_medium = /** @type {((inputs?: Directory_Agent_Readiness_Confidence_MediumInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Confidence_MediumInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_confidence_medium(inputs)
	return zh_directory_agent_readiness_confidence_medium(inputs)
});
export { directory_agent_readiness_confidence_medium as "directory.agent_readiness.confidence.medium" }